import { generateDenominatorNumerator } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { randomIntFromInterval, randomInRange } from '~/bootcamp/Activities/utils/activities.utils'

/**
 * Generates a random denominator from denominator list
 * @param denominators available denominators
 * @param denominatorHistory history of denominator
 * @returns a array with denominator and result
 */
export function generateRandomDenominatorAndAnswer(
  denominators: number[],
  denominatorHistory: number[],
): [denominator: number, result: string] {
  let denominatorIndex = randomInRange(0, denominators.length)
  denominatorIndex = validateDenominator(denominatorIndex, denominators, denominatorHistory)
  return [denominators[denominatorIndex], (1 / denominators[denominatorIndex]).toFixed(2)]
}

/**
 * validate generated denominator index
 * @param denominatorIndex current generated index of the denominator
 * @param denominators available denominators
 * @param denominatorHistory history of denominator
 * @returns validated denominator index
 */
function validateDenominator(denominatorIndex: number, denominators: number[], denominatorHistory: number[]): number {
  if (denominatorHistory.includes(denominators[denominatorIndex])) {
    denominatorIndex++
    if (denominatorIndex === denominators.length) denominatorIndex = 0
    return validateDenominator(denominatorIndex, denominators, denominatorHistory)
  }
  return denominatorIndex
}

/**
 * It generates a random numerator and denominator for UnitFractionNumline activity, and then validates the numerator against the
 * history
 * @param {number} minNumerator - The minimum value for the numerator.
 * @param {number} maxNumerator - The maximum value of the numerator.
 * @param {number} minDenominator - The minimum value for the denominator.
 * @param {number} maxDenominator - The maximum denominator that can be generated.
 * @param {number[]} history - an array of numbers that have already been used in the current activity.
 * @param {number} difficultyLevel - current difficulty level
 * @returns { numerator: number; denominator: number }
 */
export function generateNumeratorDenominatorForNumline(
  minNumerator: number,
  maxNumerator: number,
  minDenominator: number,
  maxDenominator: number,
  difficultyLevel: number,
  history: number[],
): { numerator: number; denominator: number } {
  if (difficultyLevel === 1) {
    return generateDenominatorNumerator(minNumerator, maxNumerator, minDenominator, maxDenominator, history)
  }
  const denominator = randomIntFromInterval(minDenominator, maxDenominator)
  const numerator = randomIntFromInterval(minNumerator, Math.min(maxNumerator, 2 * denominator), history)
  return { numerator, denominator }
}
